let base = require('js-base64').Base64;

const hostname = window.location.hostname
console.log('hostname----',hostname)
const port = window.location.port;
const isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
let arr =  hostname.split('.')
let  isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题
console.log('isDTYProEnv----',isDTYProEnv)
// var testUrl=arr.splice(1,1).join('.') +'.wdeduc.com'
// let API = arr[0].includes('hrss') || arr[0].includes('wd') ?  `https://hrss-api.${arr.splice(1).join('.')}` : `https://hrss-api.${isDTYProEnv ? arr.splice(1).join('.') : arr.splice(2).join('.')}`
// let API = `https://hrss-api.${isDTYProEnv ? arr.splice(1).join('.') :testUrl}`
var testUrl;
var shengchanUrl;
if(isDTYProEnv){
  shengchanUrl = arr.splice(1).join('.');
  //arr.splice(1).join('.');
}else{
  testUrl = arr.splice(1,1).join('.') +'.wdeduc.com'
}
let API = `https://hrss-api.${isDTYProEnv ? shengchanUrl:testUrl}`
if(isIP.test(hostname) || !!port){
    API = 'https://hrss-api.testing3.wdeduc.com';
} else if (hostname.includes('fat')) {
    API = 'https://hrss-api.fat.wdeduc.com';
}
let confUrl = port? base.encode('jiazheng.saas-pc.fat.wdeduc.com:80') :  base.encode(hostname);

export default {
  API,
  confUrl
};
